import React from 'react';
import { PlayCircle } from 'lucide-react';
import { CADVisualization } from './CADVisualization';
export function Hero() {
  return <section className="relative bg-gradient-to-b from-slate-50 to-white pt-20 pb-24 px-6" data-id="element-91">
      <div className="max-w-7xl mx-auto" data-id="element-92">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-93">
          {/* Left: Copy + CTAs */}
          <div className="space-y-8" data-id="element-94">
            <div className="space-y-4" data-id="element-95">
              <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight" data-id="element-96">
                Stop manual CAD data entry. Sync designs directly to your ERP in
                seconds.
              </h1>
              <p className="text-xl text-slate-600 leading-relaxed" data-id="element-97">
                Eliminate redundant work, reduce errors, and accelerate
                manufacturing workflows. Synchronize engineering and business
                data in real-time.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-98">
              <a href="https://calendly.com/alex-thruline/cad-sync-meeting" target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all hover:scale-[1.02] shadow-thruline text-center" data-id="element-99">
                Start Free Trial
              </a>
              <a href="https://www.loom.com/share/3301ec1bc64a43a7aa849f0922b2e412" target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-white text-slate-700 font-semibold rounded-lg border-2 border-slate-200 hover:border-slate-300 transition-all hover:scale-[1.02] flex items-center justify-center gap-2" data-id="element-100">
                <PlayCircle className="w-5 h-5" data-id="element-101" />
                Watch 2-min Demo
              </a>
            </div>

            <p className="text-sm text-slate-500" data-id="element-102">
              14-day free trial • No credit card required
            </p>
          </div>

          {/* Right: CAD Visualization */}
          <div className="relative" data-id="element-103">
            <CADVisualization data-id="element-104" />
          </div>
        </div>
      </div>
    </section>;
}